import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@wz-environments';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import {
  ApiServiceBase,
  MtxDataLoginResponse,
  MtxLoginResponse,
} from './api-service-base';

@Injectable({ providedIn: 'root' })
export class MtxApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
    private cookieService: CookieService,
  ) {
    super(config, httpClient, 'mtxdataclient');
  }

  getToken(): Observable<MtxLoginResponse> {
    return this.getMtxLogin('/login');
  }

  async letEncrypt(data: any) {
    let token = await this.getTokenFromStorage();
    return this.letsEncryptDataClient('/encrypt', token, data).toPromise();
  }

  async letDecrypt(encrypted: string) {
    let token = await this.getTokenFromStorage();
    return this.letsDecryptDataClient('/decrypt', token, encrypted).toPromise();
  }

  uncapitalize(str1: string) {
    return str1.charAt(0).toLowerCase() + str1.slice(1);
  }

  capitalize(str1: string) {
    return str1.charAt(0).toUpperCase() + str1.slice(1);
  }

  async getTokenFromStorage() {
    let tokenMtx = localStorage.getItem('mtx-token');
    if (tokenMtx) {
      let token: MtxDataLoginResponse = JSON.parse(tokenMtx);
      let exp: number = new Date(token.expiration).getTime();
      let date: number = new Date().getTime();

      const diffInMinutes = Math.floor((exp - date) / (1000 * 60));
      if (diffInMinutes < 10) {
        let token: any = await this.getToken().toPromise();

        if (token && token.data && token.data.token) {
          localStorage.setItem('mtx-token', JSON.stringify(token.data));
        }

        return token.data.token;
      } else {
        return token.token;
      }
    } else {
      let token: any = await this.getToken().toPromise();

      if (token && token.data && token.data.token) {
        localStorage.setItem('mtx-token', JSON.stringify(token.data));
      }

      return token.data.token;
    }
  }

  saveDataClient(data: any) {
    // clean data
    let dataStr: string = JSON.stringify(data);
    dataStr = dataStr.replace(/(<script>.*<\/script>)/g, '');
    localStorage.setItem('dataCleint', dataStr);
  }

  updateDataClient(data: any) {
    // clean data
    let dataStr: string = JSON.stringify(data);
    dataStr = dataStr.replace(/(<script>.*<\/script>)/g, '');
    localStorage.setItem('dataCleint', dataStr);

    this.updateDataClientCookie();
  }

  async updateDataClientCookie() {
    let dataCleint = localStorage.getItem('dataCleint');
    dataCleint = dataCleint
      ? dataCleint.replace(/(<script>.*<\/script>)/g, '')
      : null;
    if (dataCleint) {
      this.letEncrypt(JSON.parse(dataCleint)).then((data: any) => {
        if (data && data.request && data.request.encrypt) {
          let expireIn: Date = new Date();
          expireIn.setFullYear(expireIn.getFullYear() + 1);
          // updateCookies
          let options: CookieOptions = {
            domain: environment.domainMTX, // change if deploi
            path: '/',
            httpOnly: false,
            sameSite: 'none',
            secure: true,
            expires: expireIn,
          };
          this.cookieService.put(
            'datasClientMTX',
            data.request.encrypt,
            options,
          );
        }
      });
    }
  }

  saveDataClientPersonne(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }
}
